module.exports = __webpack_public_path__ + "static/media/reco_3.48fecceb.jpg";